export const DEFAULT_OPERATOR_RIG_SETTINGS = {
  bridgeUrl: 'ws://127.0.0.1:8765',
  backends: {
    wsjtx: { enabled: true, udpPort: 2237 },
    flrig: { enabled: true, host: '127.0.0.1', port: 12345 },
    fldigi: { enabled: true, host: '127.0.0.1', port: 7362 },
    hamlib: { enabled: false, rigModel: '1', rigPort: '/dev/ttyUSB0', rigBaud: '9600' }
  },
  primaryBackend: 'auto',
  followRig: true,
  wsjtxAutoLog: false,
  wsjtxDefaults: {
    classSent: '',
    locationReceived: ''
  }
};

export function normalizeRigSettings(input = {}) {
  const settings = JSON.parse(JSON.stringify(DEFAULT_OPERATOR_RIG_SETTINGS));

  if (typeof input.bridgeUrl === 'string' && input.bridgeUrl.trim()) {
    settings.bridgeUrl = input.bridgeUrl.trim();
  }
  if (typeof input.primaryBackend === 'string') {
    settings.primaryBackend = input.primaryBackend;
  }
  if (typeof input.followRig === 'boolean') {
    settings.followRig = input.followRig;
  }
  if (typeof input.wsjtxAutoLog === 'boolean') {
    settings.wsjtxAutoLog = input.wsjtxAutoLog;
  }
  if (input.backends && typeof input.backends === 'object') {
    Object.keys(input.backends).forEach((key) => {
      if (settings.backends[key]) {
        settings.backends[key] = {
          ...settings.backends[key],
          ...input.backends[key]
        };
      }
    });
  }
  if (input.wsjtxDefaults && typeof input.wsjtxDefaults === 'object') {
    settings.wsjtxDefaults = {
      ...settings.wsjtxDefaults,
      ...input.wsjtxDefaults
    };
  }

  return settings;
}

export function loadLocalRigSettings(callsign) {
  const key = `cq_rush_rig_settings_${String(callsign || '').trim().toUpperCase()}`;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return DEFAULT_OPERATOR_RIG_SETTINGS;
    }
    return normalizeRigSettings(JSON.parse(raw));
  } catch {
    return DEFAULT_OPERATOR_RIG_SETTINGS;
  }
}

export function saveLocalRigSettings(callsign, settings) {
  const key = `cq_rush_rig_settings_${String(callsign || '').trim().toUpperCase()}`;
  localStorage.setItem(key, JSON.stringify(normalizeRigSettings(settings)));
}
